import config from 'common/config'
import Constants from 'common/constants'
import Http from 'common/http'
import {
  ChangePasswordRequestInterface,
  ChangePasswordResponseInterface,
  SigninRequestInterface,
  SigninResponseInterface,
  VerifyResetKeyRequestInterface,
  VerifyResetKeyResponseInterface
} from './interfaces'

const basePath = `${config.API_URL}/${Constants.API_URl_PREFIX}/auth`

const AuthService = {
  login: (
    email: string,
    password: string
  ): Promise<SigninResponseInterface> => {
    return Http.post<
      Omit<SigninRequestInterface, 'code'>,
      SigninResponseInterface
    >(`${basePath}/signin`, { email, password }, { credentials: 'omit' })
  },

  refresh: (refreshToken: string): Promise<SigninResponseInterface> => {
    return Http.post<{ refreshToken: string }, SigninResponseInterface>(
      `${basePath}/refresh`,
      { refreshToken },
      { credentials: 'omit' }
    )
  },

  forgetPassword: (email: string): Promise<void> => {
    try {
      return Http.post<{ email: string }, void>(
        `${basePath}/forget-password`,
        { email },
        { credentials: 'omit' }
      )
    } catch (error) {
      return Promise.reject(error)
    }
  },

  changePassword: (
    key: string,
    password: string
  ): Promise<ChangePasswordResponseInterface> => {
    return Http.post<
      ChangePasswordRequestInterface,
      ChangePasswordResponseInterface
    >(`${basePath}/change-password`, { key, password }, { credentials: 'omit' })
  },

  verifyResetKey: (key: string): Promise<VerifyResetKeyResponseInterface> => {
    return Http.post<
      VerifyResetKeyRequestInterface,
      VerifyResetKeyResponseInterface
    >(`${basePath}/verify-reset-key`, { key }, { credentials: 'omit' })
  }
}

export default AuthService
